(function () {
  module.exports = {
    toArabic: require('./lib/toArabic.js'),
    toRoman:require('./lib/toRoman.js')
  };
})();
